import { observable } from 'mobx';

const AlimtalkSendModalModel = observable({
    alimtalkSendData : null,
    setAlimtalkSendData(data) {
        this.alimtalkSendData = {
            businessName : data?.businessName || "",
            targets : data?.targets?.map((target) => {
                return {
                    name : target?.name || "",
                    phoneNumber : target?.phoneNumber || "",
                    id : target?.id || ""
                }
            }),
            selectedIds : [],
            content : ""
        }
    }
});

export default AlimtalkSendModalModel;